import React from 'react'
import { Link } from 'react-router-dom'
import {
  hasUserPermission,
  hasUserPermissionOnMegaMenuGroupItem,
} from '../../utils/permissionHelper'

export const collections = [
  {
    label: 'Payment Plans',
    link: '/payment_plan',
    permission: 'payment_plan_read',
  },
  {
    label: 'External Collections',
    link: '/external_collection',
    permission: 'external_collection_read',
  },
  {
    label: 'External Collection Batch Placements',
    link: '/external_collection_batch_placement',
    permission: 'external_collection_batch_placement_read',
  },
  {
    label: 'Collection Payment Uploads',
    link: '/queue_collection_payment_upload',
    permission: 'queue_collection_payment_upload_read',
  },
]

export default function NavCollection(props) {
  return (
    <div className="navbar-dropdown lox-navigation-bar__content__dropdown is-block p-0">
      <div className=" m-0 p-3 is-size-7 lox-navigation-bar__content__dropdown__container">

       {hasUserPermissionOnMegaMenuGroupItem(props.userPermissions, collections) && (
          <div className="mt-2">
            <h2 className="title is-size-5 mb-0 has-text-primary">Collections</h2>
            {collections.map(
              (collection) =>
                hasUserPermission(props.userPermissions, collection.permission) && (
                  <Link
                    className="navbar-item"
                    to={`${collection.link}`}
                    onClick={props.onLink}
                    key={collection.permission}
                  >
                    {collection.label}
                  </Link>
                )
            )}
            </div>
        )}

      </div>
    </div>
  )
}
